let menu = [
  {
    label: 'Customer Service',
    routes: [
      { label: 'Coupon Manager', to: '/coupon-management', permissions: ['read-coupons'] },
      { label: 'Inventory Lookup', to: '/inventoryLookup', permissions: ['read-inventory'] },
      { label: 'Order Update', to: '/order-change/update', permissions: ['manage-order-updates'] },
      { label: 'Order Update History', to: '/order-change/history', permissions: ['manage-order-updates'] },
      { label: 'Return Authorization', to: '/order-return/update', permissions: ['manage-order-returns'] },
      { label: 'Held Orders', to: '/monitoring/kitsilano/hold', permissions: ['manage-held-orders'] },
      { label: 'Missing Orders', to: '/monitoring/kitsilano/missing-orders', permissions: ['manage-held-orders'] },
      { label: 'Pending FBA Orders', to: '/monitoring/kitsilano/pending-fba-orders', permissions: ['manage-monitoring'] },
      { label: 'Unfulfilled Orders', to: '/monitoring/kitsilano/unfulfilled-orders', permissions: ['manage-held-orders'] },
      { label: 'Uncaptured Orders', to: '/monitoring/oms/uncaptured-orders', permissions: ['manage-uncaptured-orders'] },
      { label: 'Refunds', to: '/refunds', permissions: ['manage-order-updates']},
      { label: 'Order Fulfillment', to: '/order-fulfillment', permissions: ['manage-order-updates']},
      { label: 'ICS Postal Codes', to: '/ics', permissions: ['manage-ics-upload']},
      { label: 'Ground Shipping', to: '/ground-shipping', permissions: ['manage-ground-shipping']},
      { label: 'Manage Dropdown Lists', to: '/manage-dropdown-lists/customer-service', permissions: ['manage-dropdown-management'] },
      { label: 'Amazon Blocked Customers', to: '/blocked-customers', permissions: ['manage-blocked-customer']},
      { label: 'Amazon Returns Sync', to: '/monitoring/kitsilano/amazon-returns-sync', permissions: ['manage-monitoring'] },
    ],
  },

  {
    label: 'Finance',
    routes: [
      { label: 'Credit Dashboard', to: '/credit-dashboard', permissions: ['read-credit-accounts', 'read-credit-applications'] },
      { label: 'Order Reconciliation', to: '/reports/order-reconciliation', permissions: ['read-finance-reports'] },
      { label: 'Aftership Reconciliation', to: '/reports/aftership-reconciliation', permissions: ['read-finance-reports'] },
      { label: 'Gift Card Report', to: '/reports/gift-card-report', permissions: ['read-finance-reports'] },
      { label: 'Manage Dropdown Lists', to: '/manage-dropdown-lists/finance', permissions: ['manage-dropdown-management'] },
    ],
  },

  {
    label: 'Technology',
    routes: [
      { label: 'Manage Users', to: '/users', permissions: ['read-users'] },
      { label: 'Manage Roles', to: '/roles', permissions: ['manage-access'] },
    ],
  },

  {
    label: 'Monitoring',
    permissions: ['manage-monitoring'],
    routes: [
      { label: 'Kitsilano Queues', to: '/monitoring/kitsilano/queues' },
      { label: 'Order Flow Status', to: '/monitoring/order/flow' },
      { label: 'D365 Webhooks', to: '/monitoring/d365/webhook-table' },
      { label: 'Horizon', href: '/horizon', external: true },
    ],
  },

  {
    label: 'Backend',
    routes: [
      { label: 'Backend Dashboard', to: '/backend-ui', permissions: ['manage-backend-ui']},
    ],
  },
];

export default menu;
